import Request from 'components/Request';
import { __ } from 'i18n/index';

// Connect codes in chat text (boo#862 on Slippi, ANGE#858 on Brawl Online):
// letters, '#', digits, shown uppercase as Slippi does.
// Text_Filter::parse_connect_code is the server's copy of the pattern.
export const SLIPPI_ID_TYPE = 14;
export const BRAWL_ONLINE_CODE_TYPE = 16;
// SSF2's McLeodGaming Network username. It isn't a connect code; SSF2 replays name players by it.
export const MGN_USERNAME_TYPE = 8;
// Player_External_Connection::CONNECT_CODE_TYPES
const CONNECT_CODE_TYPES = [SLIPPI_ID_TYPE, BRAWL_ONLINE_CODE_TYPE];

const CONNECT_CODE = /(?<![\w/.#-])([A-Za-z]{1,7})#(\d{1,7})(?![\w#])/;

export function usesConnectCodes(type) {
	return CONNECT_CODE_TYPES.includes(Number(type));
}

export function findConnectCode(text) {
	const match = CONNECT_CODE.exec(text || '');
	return match ? `${match[1].toUpperCase()}#${match[2]}` : null;
}

// The ladder's name for the field ("Slippi ID", "Brawl Online Code").
export function connectCodeFieldName(ladder, type) {
	const field = (ladder?.connected_field_types || []).find((fieldType) => fieldType.type === type);
	return field ? field.name : __('Code');
}

// Codes you said aren't yours, so the room card doesn't ask about them again.
// Kept per browser; without storage it simply asks again.
const DISMISSED_KEY = 'slippiCodesNotMine';

function readDismissed() {
	try {
		return JSON.parse(window.localStorage.getItem(DISMISSED_KEY) || '[]');
	} catch(error) {
		return [];
	}
}

function writeDismissed(codes) {
	try {
		window.localStorage.setItem(DISMISSED_KEY, JSON.stringify(codes));
	} catch(error) {
		// Storage blocked: the card asks again next time.
	}
}

export function isDismissedConnectCode(code) {
	return readDismissed().includes(code);
}

export function dismissConnectCode(code) {
	const codes = readDismissed();
	if(!codes.includes(code)) {
		writeDismissed([...codes, code]);
	}
}

export function undismissConnectCode(code) {
	writeDismissed(readDismissed().filter((dismissed) => dismissed !== code));
}

export function myConnectCode(type) {
	const value = typeof myUser === 'undefined' ? null : myUser?.connected_fields?.[type]?.primary_value;
	return value || null;
}

// Saves your code for the field ('' clears it) through the profile endpoint,
// which also pushes your match. Resolves to the saved value, or rejects with
// the reason.
export function saveMyConnectCode(type, value) {
	return Request.post('/api/v1/player/update_player_external_value', {
		player_external_connection_type: type,
		value,
	}).then((response) => {
		if(response.error) {
			throw response.error;
		}
		const code = response.value || null;
		if(typeof myUser !== 'undefined' && myUser) {
			myUser.connected_fields = { ...myUser.connected_fields, [type]: { primary_value: code } };
		}
		return code;
	});
}
